import { A, useSearchParams } from "@solidjs/router"
import { Show } from "solid-js"
import { useLanguage } from "@/context/language"
import { workspaceHref } from "@/cowork/workspace-route"
import { BackLabel } from "./back-label"

export function SettingsReturnLink(props: { always?: boolean; when?: boolean; breadcrumb?: boolean }) {
  const language = useLanguage()
  const [query] = useSearchParams()
  return <Show when={props.when !== false && (props.always || query.from === "settings")}>
    <div class={props.breadcrumb ? "inline-flex items-center gap-3" : "mb-4"}>
      <A href={workspaceHref("/settings")}
        class="inline-flex min-h-8 items-center rounded-sm text-[12px] text-v2-text-text-muted hover:text-v2-text-text-base hover:underline underline-offset-4 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-v2-border-border-strong">
        <Show when={props.breadcrumb} fallback={<BackLabel>{language.t("cowork.accountingNav.backToSettings")}</BackLabel>}>
          {language.t("cowork.enterprise.nav.settings")}
        </Show>
      </A>
      <Show when={props.breadcrumb}><span aria-hidden="true" class="text-v2-text-text-muted">/</span></Show>
    </div>
  </Show>
}
